<template>
  <div class="privacy-footer">
    <p class="text-muted">
      <strong>Ultimo aggiornamento:</strong> {{ updateDate }}
    </p>
    <p class="text-muted">
      <small>
        Questa Privacy Policy è conforme al Regolamento (UE) 2016/679 (GDPR) e al 
        D.Lgs. 196/2003 come modificato dal D.Lgs. 101/2018.
      </small>
    </p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyFooter',
  props: {
    updateDate: {
      type: String,
      default: 'Luglio 2026'
    }
  }
}
</script>

<style scoped>
.privacy-footer {
  text-align: center;
  padding-top: 2rem;
  border-top: 2px solid #e9ecef;
  margin-top: 2rem;
}

.privacy-footer p {
  margin-bottom: 0.5rem;
}
</style>

